import React, { createContext, useContext } from 'react';
import { useQuery } from 'react-query';
import { api } from '../services/api';

const CurrencyContext = createContext();

export const useCurrency = () => {
  const ctx = useContext(CurrencyContext);
  if (!ctx) throw new Error('useCurrency must be used within a CurrencyProvider');
  return ctx;
};

const SYMBOLS = {
  EUR: '€',
  USD: '$',
  GBP: '£'
};

export const CurrencyProvider = ({ children }) => {
  // React Query ile cache'lenmiş sorgu - sadece bir kez çalışır
  const { data } = useQuery(
    'defaultCurrency',
    async () => {
      const res = await api.get('/api/settings/default_currency');
      return res?.data?.data?.setting?.value || 'EUR';
    },
    {
      staleTime: Infinity, // Asla stale olmasın
      cacheTime: Infinity, // Cache'te sonsuza kadar kalsın
      refetchOnMount: false, // Mount'ta tekrar fetch etme
      refetchOnWindowFocus: false, // Window focus'ta tekrar fetch etme
      retry: false, // Hata durumunda tekrar deneme
      onError: () => {
        // Sessiz fallback
      }
    }
  );

  const defaultCurrency = data || 'EUR';

  const getSymbol = (code) => SYMBOLS[code] || '';

  const formatCurrency = (amount, code) => {
    const c = code || defaultCurrency;
    const num = Number(amount || 0);
    const lang = localStorage.getItem('language') || 'de';
    const locale = lang === 'de' ? 'de-DE' : 'en-US';
    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: c,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(num);
    } catch (_) {
      // Fallback: number with thousand separator + trailing symbol
      const symbol = getSymbol(c);
      return `${num.toLocaleString(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${symbol}`;
    }
  };

  return (
    <CurrencyContext.Provider value={{ defaultCurrency, getSymbol, formatCurrency }}>
      {children}
    </CurrencyContext.Provider>
  );
};
